var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M8 12.609L3.674 15 4.5 9.935 1 6.348l4.837-.74L8 1l2.163 4.609L15 6.348l-3.5 3.587.826 5.065z","fillRule":"evenodd"}));
}

StarInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = StarInline;

StarInline.default = StarInline;
